import React, { Component } from "react";
import "./../css/master.css";
import "./../css/internalPo.css";
import Header from "./../js/header.js";
import axiosInstance from '../api/csAxios';
import $ from "jquery";
import DatePicker from "react-datepicker";
//import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const { IMG_TYPES } = require("./imgType");

var httpURL = "";
var sortVal = "";
var queryString = require("querystring");
var lstIpo = [];
var lstTransporter = [];
var ipoStatusList = [];
var allIpo = [];
var tempList = [];
var COL_IPO_QUOTEID = "td:eq(0)";
var COL_IPO_IPOID = "td:eq(1)";
var COL_IPO_IPONO = "td:eq(2)";
var COL_IPO_CREATED = "td:eq(3)";
var COL_IPO_WEAVERID = "td:eq(4)";
var COL_IPO_WEAVER = "td:eq(5)";
var COL_IPO_STATUSID = "td:eq(6)";
var COL_IPO_STATUS = "td:eq(7)";

var COL_INTERNAL_BPOID = "td:eq(0)";
var COL_INTERNAL_BPONO = "td:eq(1)";
var COL_INTERNAL_SEASONID = "td:eq(2)";
var COL_INTERNAL_SEASON = "td:eq(3)";
var COL_INTERNAL_DELDT = "td:eq(4)";
var COL_INTERNAL_STYLEID = "td:eq(5)";
var COL_INTERNAL_STYLE = "td:eq(6)";
var COL_INTERNAL_COLOR = "td:eq(7)";
var COL_INTERNAL_DESIGNID = "td:eq(8)";
var COL_INTERNAL_DESIGNNOCOLOR = "td:eq(9)";
var COL_INTERNAL_RATE = "td:eq(10)";
var COL_INTERNAL_LENGTH = "td:eq(11)";
var COL_INTERNAL_WIDTH = "td:eq(12)";
var COL_INTERNAL_BUFFERDAY = "td:eq(13)";
var COL_INTERNAL_CONSTRUCTION = "td:eq(14)";
var COL_INTERNAL_YARNCOUNT = "td:eq(15)";
var COL_INTERNAL_QUALITYID = "td:eq(16)";
var COL_INTERNAL_QUALITY = "td:eq(17)";
var COL_INTERNAL_IPODESIGNID = "td:eq(22)";

var COL_TPT_TPTID = "td:eq(0)";
var COL_TPT_TPT = "td:eq(1)";
var COL_TPT_CONTACTPERSON = "td:eq(2)";
var COL_TPT_CONTACTCITY = "td:eq(3)";
var COL_TPT_PHONE = "td:eq(4)";

//var glbIpoDesignId = localStorage.getItem("ipoDesignId");

class InternalPo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ipo: [],
      startDate: null,
      endDate: null,
      loader: "none",
      opacity: 1,
      width: "98.6%",
      width1: "98.6%",
      ipoStatusList: [],
      width2: "98.6%",
      allIpo: [],
      glbIpoDesignId: localStorage.getItem("ipoDesignId"),
      lstIPODsgn: [],
      // lstIPODsgn: [{ "quoteId": 130, "bpoId": 98, "bpoStyleId": 138, "ipoDesignId": 29, "bpo": "CODE- 2007", "seasonId": 5, "season": "SP'20", "designId": 217, "designNoColor": "2014 YELLOW", "img": "217.jpg", "deliveryDt": "03-12-2019", "style": "2014", "color": "yellow", "rate": 58.0, "construction": "72x72", "yarnCount": "", "length": 11020, "buyerLength": 11020, "width": "44\"", "quality": "COTTON CHECKS", "widthId": 1, "constructionId": 3, "yarnCountId": 0, "qualityId": 10 }]
    };
  }

  async componentDidMount() {
    this.handleResize();
    window.addEventListener("load", this.handleResize);
    window.addEventListener("resize", this.handleResize);

    var startDate = new Date();
    var startDate = startDate.setDate(startDate.getDate() - 60);
    await this.setState({
      startDate: new Date(startDate),
    });
    var endDate = new Date();
    var endDate = endDate.setDate(endDate.getDate() + 60);
    await this.setState({
      endDate: new Date(endDate),
    });
    $("#filterStatusCmb").prepend(
      $("<option> </option>").val(0).html("Status")
    );
    this.getIpo();
  }

  handleResize = () => {
    var width = $(".tableLayout1").parent().width() - 18;
    var width1 = $(".tableLayout2").parent().width() - 18;
    var width2 = $(".tableLayout3").parent().width() - 18;
    this.setState({ width: width, width1: width1, width2: width2 });
  };

  getIpo = () => {
    var fromDt = $("#inp_fromDate").val();
    var toDt = $("#inp_toDate").val();
    if (Date.parse(this.state.startDate) > Date.parse(this.state.endDate)) {
      toast.warning("End Date should be greater than Start Date");
      return false;
    }
    var ipo = { fromDt: fromDt, toDt: toDt };
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/ipo/list",
        queryString.stringify({ ipo: JSON.stringify(ipo) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            ipo: response.data.lstIPODesigns,
            ipoStatusList: response.data.ipoStatusList,
          });
          ipoStatusList = this.state.ipoStatusList;
          lstIpo = this.state.ipo;

          this.setIpoTable();
          this.fillStatusCmb();
          this.getAllIpo();
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "No Internal PO exist")
            $("#ipoTableBody tr").remove();
          lstIpo = [];

          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };

  getAllIpo = () => {
    var fromDt = "30-08-2019";
    var toDt = $("#inp_toDate").val();

    var ipo = { fromDt: fromDt, toDt: toDt };
    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .post(
        httpURL + "/a/ipo/list",
        queryString.stringify({ ipo: JSON.stringify(ipo) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          this.setState({
            allIpo: response.data.lstIPODesigns,
          });
          this.setIpoTable();
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((error) => {
        toast.error("Service failed " + error);
      });
  };
  fillStatusCmb = () => {
    $("#filterStatusCmb").empty();
    $("#filterStatusCmb").prepend(
      $("<option> </option>").val(0).html("Status")
    );
    for (var i = 0; i < ipoStatusList.length; i++) {
      var status = ipoStatusList[i];
      $("#filterStatusCmb").append(
        $("<option> </option>")
          .val(i + 1)
          .html(status)
      );
    }
  };

  setIpoTable = () => {
    $("#ipoTableBody tr").remove();
    var table = document.getElementById("ipoTable");
    var tbody = document.getElementById("ipoTableBody");
    var filterIpoNo = $("#filterIpoNo").val().trim().toLowerCase();
    var filterWeaver = $("#filterWeaver").val().trim().toLowerCase();
    var filterBpoNo = $("#filterBpoNo").val().trim().toLowerCase();
    var filterDesignColor = $("#filterDesignColor").val().trim().toLowerCase();
    var filterStatus = $("#filterStatusCmb").find("option:selected").text();

    if (
      filterIpoNo.length != 0 ||
      filterWeaver.length != 0 ||
      $("#cbx").prop("checked") == true
    ) {
      var allIpoLst = this.state.allIpo;
      for (var i = 0; i < allIpoLst.length; i++) {
        var quoteId = allIpoLst[i].quoteId;
        var ipoId = allIpoLst[i].ipoId;
        var ipoNo = allIpoLst[i].ipoNo;
        var buyerPOId = allIpoLst[i].buyerPOId;
        var buyerPO = allIpoLst[i].buyerPO;
        var createdOn = allIpoLst[i].createDttm;
        createdOn = createdOn == "" || createdOn == null ? "-" : createdOn;
        var weaverId = allIpoLst[i].weaverId;
        var weaver = allIpoLst[i].weaver;
        var ipoStatusId = allIpoLst[i].ipoStatusId;
        var ipoStatus = allIpoLst[i].ipoStatus;
        var bpoId = allIpoLst[i].bpoId;
        var bpoNo = allIpoLst[i].bpo;
        var seasonId = allIpoLst[i].seasonId;
        var season = allIpoLst[i].season;
        var deliveryDt = allIpoLst[i].deliveryDt;
        deliveryDt = deliveryDt == "" || deliveryDt == null ? "-" : deliveryDt;
        var styleId = allIpoLst[i].bpoStyleId;
        var style = allIpoLst[i].style;
        var color = allIpoLst[i].color;
        var designId = allIpoLst[i].designId;
        var designNoColor = allIpoLst[i].designNoColor;
        var rate = allIpoLst[i].rate;
        var length = allIpoLst[i].length;
        var width = allIpoLst[i].width;
        var bufferDays = allIpoLst[i].bufferDays;
        var construction = allIpoLst[i].construction;
        var yarnCount = allIpoLst[i].yarnCount;
        var qualityId = allIpoLst[i].qualityId;
        var quality = allIpoLst[i].quality;
        var ipoDesignId = allIpoLst[i].ipoDesignId;
        var buyerLength = allIpoLst[i].buyerLength;
        var quoteAcceptedStatus = allIpoLst[i].quoteAcceptedStatus;

        var row = document.createElement("tr");
        row.id = "ipoDesignId" + ipoDesignId;

        if (ipoNo.toLowerCase().indexOf(filterIpoNo) === -1) continue;
        if (weaver.toLowerCase().indexOf(filterWeaver) === -1) continue;
        if (bpoNo.toLowerCase().indexOf(filterBpoNo) === -1) continue;
        if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
          continue;
        if (filterStatus !== "Status" && ipoStatus !== filterStatus) continue;
        if ($("#cbx").prop("checked") == true && quoteAcceptedStatus == false)
          continue;

        var pipe = length + " | " + width + " | " + construction;

        this.addTD(row, quoteId, "no-display");
        this.addTD(row, ipoId, "no-display");
        if (quoteAcceptedStatus == true) {
          this.addTD(row, ipoNo, "changes");
          $("td.changes").prop("tooltipText", "Quotes Not Accepted");
          $(".changes").attr("title", "Quotes Not Accepted");
        } else {
          this.addTD(row, ipoNo, "");
        }
        this.addTD(row, createdOn, "text-center");
        this.addTD(row, weaverId, "no-display");
        this.addTD(row, weaver, "");
        this.addTD(row, bpoId, "no-display");
        this.addTD(row, bpoNo, "");
        this.addTD(row, seasonId, "no-display");
        this.addTD(row, season, "");
        this.addTD(row, deliveryDt, "text-center");
        this.addTD(row, styleId, "no-display");
        this.addTD(row, style, "");
        this.addTD(row, color, "");
        this.addTD(row, designId, "no-display");
        this.addTD(row, designNoColor, "");
        this.addTD(row, rate, "text-right");
        this.addTD(row, pipe, "text-center");
        this.addTD(row, bufferDays, "no-display");
        this.addTD(row, yarnCount, "");
        this.addTD(row, qualityId, "no-display");
        this.addTD(row, quality, "");
        this.addTD(row, ipoDesignId, "no-display");
        this.addTD(row, ipoStatusId, "no-display");
        this.addTD(row, ipoStatus, "");
        this.addTDEdit(
          row,
          "glyphicon glyphicon-option-vertical",
          "text-center"
        );

        tbody.append(row);
      }
    } else {
      for (var i = 0; i < lstIpo.length; i++) {
        var quoteId = lstIpo[i].quoteId;
        var ipoId = lstIpo[i].ipoId;
        var ipoNo = lstIpo[i].ipoNo;
        var buyerPOId = lstIpo[i].buyerPOId;
        var buyerPO = lstIpo[i].buyerPO;
        var createdOn = lstIpo[i].createDttm;
        createdOn = createdOn == "" || createdOn == null ? "-" : createdOn;
        var weaverId = lstIpo[i].weaverId;
        var weaver = lstIpo[i].weaver;
        var ipoStatusId = lstIpo[i].ipoStatusId;
        var ipoStatus = lstIpo[i].ipoStatus;
        var bpoId = lstIpo[i].bpoId;
        var bpoNo = lstIpo[i].bpo;
        var seasonId = lstIpo[i].seasonId;
        var season = lstIpo[i].season;
        var deliveryDt = lstIpo[i].deliveryDt;
        deliveryDt = deliveryDt == "" || deliveryDt == null ? "-" : deliveryDt;
        var styleId = lstIpo[i].bpoStyleId;
        var style = lstIpo[i].style;
        var color = lstIpo[i].color;
        var designId = lstIpo[i].designId;
        var designNoColor = lstIpo[i].designNoColor;
        var rate = lstIpo[i].rate;
        var length = lstIpo[i].length;
        var width = lstIpo[i].width;
        var bufferDays = lstIpo[i].bufferDays;
        var construction = lstIpo[i].construction;
        var yarnCount = lstIpo[i].yarnCount;
        var qualityId = lstIpo[i].qualityId;
        var quality = lstIpo[i].quality;
        var ipoDesignId = lstIpo[i].ipoDesignId;
        var buyerLength = lstIpo[i].buyerLength;
        var quoteAcceptedStatus = lstIpo[i].quoteAcceptedStatus;

        var row = document.createElement("tr");
        row.id = "ipoDesignId" + ipoDesignId;

        if (ipoNo.toLowerCase().indexOf(filterIpoNo) === -1) continue;
        if (weaver.toLowerCase().indexOf(filterWeaver) === -1) continue;
        if (bpoNo.toLowerCase().indexOf(filterBpoNo) === -1) continue;
        if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
          continue;
        if (filterStatus !== "Status" && ipoStatus !== filterStatus) continue;
        if (
          this.state.glbIpoDesignId !== "" &&
          parseInt(this.state.glbIpoDesignId) !== parseInt(ipoDesignId)
        )
          continue;

        var pipe = length + " | " + width + " | " + construction;

        this.addTD(row, quoteId, "no-display");
        this.addTD(row, ipoId, "no-display");
        if (quoteAcceptedStatus == true) {
          this.addTD(row, ipoNo, "changes");
          $("td.changes").prop("tooltipText", "Quotes Not Accepted");
          $(".changes").attr("title", "Quotes Not Accepted");
        } else {
          this.addTD(row, ipoNo, "");
        }

        this.addTD(row, createdOn, "text-center");
        this.addTD(row, weaverId, "no-display");
        this.addTD(row, weaver, "");
        this.addTD(row, bpoId, "no-display");
        this.addTD(row, bpoNo, "");
        this.addTD(row, seasonId, "no-display");
        this.addTD(row, season, "");
        this.addTD(row, deliveryDt, "text-center");
        this.addTD(row, styleId, "no-display");
        this.addTD(row, style, "");
        this.addTD(row, color, "");
        this.addTD(row, designId, "no-display");
        this.addTD(row, designNoColor, "");
        this.addTD(row, rate, "text-right");
        this.addTD(row, pipe, "text-center");
        this.addTD(row, bufferDays, "no-display");
        this.addTD(row, yarnCount, "");
        this.addTD(row, qualityId, "no-display");
        this.addTD(row, quality, "");
        this.addTD(row, ipoDesignId, "no-display");
        this.addTD(row, ipoStatusId, "no-display");
        this.addTD(row, ipoStatus, "");
        this.addTDEdit(
          row,
          "glyphicon glyphicon-option-vertical",
          "text-center"
        );

        tbody.append(row);
      }
    }

    table.append(tbody);
    this.setState({
      glbIpoDesignId: "",
    });
  };

  setTptSlider = () => {
    var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();
    var ipoNo = $("#ipoTableBody tr.selected").find(COL_IPO_IPONO).text();
    $("#transportAddForm").trigger("reset");
    $("#inp_ipoIdT").val(ipoId);
    $("#inp_ipoNoT").val(ipoNo);

    this.setState({ loader: "block", opacity: 0.5 });
    axiosInstance
      .get(httpURL + "/a/mst/tpt/list", { withCredentials: true })
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          lstTransporter = response.data.lstTpt;
          this.setTransporterTable();
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });

    axiosInstance
      .post(
        httpURL + "/a/ipo/lsttrans",
        queryString.stringify({ ipoId: ipoId }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          var data = response.data.lstTransporter;
          $("#inp_transporterId").val(data.transporterId);
          $("#inp_transporter").val(data.transporter);
          $("#inp_contactPerson").val(data.contactPerson);
          $("#inp_city").val(data.city);
          $("#inp_phone").val(data.phoneNo);
        } else {
          toast.error(response.data.SvcMsg);
          if (response.data.SvcMsg == "You are not logged in") {
            window.location.href = window.CSURL;
            return false;
          }
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  setTransporterTable = () => {
    $("#transportTableBody tr").remove();
    var table = document.getElementById("transportTable");
    var tbody = document.getElementById("transportTableBody");
    var filterId = $("#transportId").val();
    var filterTransporter = $("#transporter").val().toLowerCase();
    var filterPerson = $("#transportContactPerson").val().toLowerCase();
    var filterCity = $("#transportCity").val().toLowerCase();
    var filterPhone = $("#transportPhone").val().toLowerCase();

    for (var i = 0; i < lstTransporter.length; i++) {
      var tptId = lstTransporter[i].tptId;
      var tpt = lstTransporter[i].tpt;
      var conPerson = lstTransporter[i].contactPerson;
      var cityId = lstTransporter[i].cityId;
      var city = lstTransporter[i].city;
      var phoneNo = lstTransporter[i].phoneNo;

      var row = document.createElement("tr");
      row.onclick = (e) => {
        $(e.target)
          .closest("tr")
          .addClass("selected")
          .siblings()
          .removeClass("selected");
      };

      if (tptId.toString().indexOf(filterId) == -1) continue;
      if (tpt.toLowerCase().indexOf(filterTransporter) == -1) continue;
      if (conPerson.toLowerCase().indexOf(filterPerson) == -1) continue;
      if (city.toLowerCase().indexOf(filterCity) == -1) continue;
      if (phoneNo.toLowerCase().indexOf(filterPhone) == -1) continue;

      this.addTD(row, tptId, "txtright");
      this.addTD(row, tpt, "");
      this.addTD(row, conPerson, "");
      this.addTD(row, city, "");
      this.addTD(row, phoneNo, "");

      tbody.append(row);
    }
    table.append(tbody);
  };

  getBuyerPOData = (ipoDesignId) => {
    var filterIpoNo = $("#filterIpoNo").val().trim().toLowerCase();
    var filterWeaver = $("#filterWeaver").val().trim().toLowerCase();
    var allIpoLst = this.state.allIpo;
    if (filterIpoNo.length != 0 || filterWeaver.length != 0) {
      for (var i = 0; i < allIpoLst.length; i++) {
        if (allIpoLst[i].ipoDesignId == ipoDesignId) {
          return allIpoLst[i];
        }
      }
      return -1;
    } else {
      for (var i = 0; i < lstIpo.length; i++) {
        if (lstIpo[i].ipoDesignId == ipoDesignId) {
          return lstIpo[i];
        }
      }
      return -1;
    }
  };

  progress = () => {
    var ipoNo = $("#ipoTableBody tr.selected").find(COL_IPO_IPONO).text();
    var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();
    console.log(ipoId);
    if (ipoId !== "" || ipoId !== null) {
      var ipoDesignId = $("#ipoTableBody tr.selected")
        .find(COL_INTERNAL_IPODESIGNID)
        .text();
      var x = this.getBuyerPOData(ipoDesignId);
      if (x != -1) {
        var bpoId = x.bpoId;
        var bpoNo = x.bpo;
        var bpoStyleId = x.bpoStyleId;
        var style = x.style;
        var color = x.color;
        var designId = x.designId;
        var designNoColor = x.designNoColor;
        var ipoDesignId = x.ipoDesignId;
        var quality = x.quality;
        var construction = x.construction;
        var width = x.width;
        var length = x.buyerLength;
        var yarnCount = x.yarnCount;
        var imageName = x.img;
        var imageUrl =
          window.httpURL +
          "/a/mst/dsn/getImage?img=" +
          imageName +
          "&imgType=" +
          IMG_TYPES.DSN;
        if (ipoDesignId === "" || ipoDesignId === null || ipoDesignId === 0) {
          toast.warning("You can not update progress for this design");
          return false;
        }
        var detail = {
          ipoDesignId: ipoDesignId,
          ipoId: ipoId,
          ipoNo: ipoNo,
          bpoId: bpoId,
          bpoNo: bpoNo,
          bpoStyleId: bpoStyleId,
          style: style,
          designId: designId,
          designNoColor: designNoColor,
          color: color,
          quality: quality,
          construction: construction,
          length: length,
          width: width,
          yarnCount: yarnCount,
          imageUrl: imageUrl,
        };
        localStorage.setItem("updateProgress", JSON.stringify(detail));
        window.open("/cs/progressUpdate", "_blank");
      }
    }
  };

  dispatch = () => {
    var ipoNo = $("#ipoTableBody tr.selected").find(COL_IPO_IPONO).text();
    var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();

    if (ipoId !== "" || ipoId !== null) {
      var ipoDesignId = $("#ipoTableBody tr.selected")
        .find(COL_INTERNAL_IPODESIGNID)
        .text();
      var x = this.getBuyerPOData(ipoDesignId);
      if (x != -1) {
        var bpoId = x.bpoId;
        var bpoNo = x.bpo;
        var bpoStyleId = x.bpoStyleId;
        var style = x.style;
        var color = x.color;
        var designId = x.designId;
        var designNoColor = x.designNoColor;
        var ipoDesignId = x.ipoDesignId;
        var quality = x.quality;
        var construction = x.construction;
        var width = x.width;
        var length = x.length;
        var yarnCount = x.yarnCount;
        var imageName = x.img;
        var imageUrl =
          window.httpURL +
          "/a/mst/dsn/getImage?img=" +
          imageName +
          "&imgType=" +
          IMG_TYPES.DSN;
        if (ipoDesignId === "" || ipoDesignId === null || ipoDesignId === 0) {
          toast.warning("You can not dispatch for this design");
          return false;
        }

        var detail = {
          ipoDesignId: ipoDesignId,
          ipoId: ipoId,
          ipoNo: ipoNo,
          bpoId: bpoId,
          bpoNo: bpoNo,
          bpoStyleId: bpoStyleId,
          style: style,
          designId: designId,
          designNoColor: designNoColor,
          color: color,
          quality: quality,
          construction: construction,
          length: length,
          width: width,
          yarnCount: yarnCount,
          imageUrl: imageUrl,
        };
        localStorage.setItem("dispatch", JSON.stringify(detail));
        window.open("/cs/dispatch", "_blank");
      }
    }
  };

  buyerDispatch = () => {
    var ipoNo = $("#ipoTableBody tr.selected").find(COL_IPO_IPONO).text();
    var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();

    if (ipoId !== "" || ipoId !== null) {
      var ipoDesignId = $("#ipoTableBody tr.selected")
        .find(COL_INTERNAL_IPODESIGNID)
        .text();
      var x = this.getBuyerPOData(ipoDesignId);
      if (x != -1) {
        var bpoId = x.bpoId;
        var bpoNo = x.bpo;
        var bpoStyleId = x.bpoStyleId;
        var style = x.style;
        var color = x.color;
        var designId = x.designId;
        var designNoColor = x.designNoColor;
        var ipoDesignId = x.ipoDesignId;
        var quality = x.quality;
        var construction = x.construction;
        var width = x.width;
        var length = x.buyerLength;
        var yarnCount = x.yarnCount;
        var imageName = x.img;
        var imageUrl =
          window.httpURL +
          "/a/mst/dsn/getImage?img=" +
          imageName +
          "&imgType=" +
          IMG_TYPES.DSN;
        var deliveryDt = x.deliveryDt;
        if (ipoDesignId === "" || ipoDesignId === null || ipoDesignId === 0) {
          toast.warning("You can not dispatch for this design");
          return false;
        }
        var detail = {
          ipoDesignId: ipoDesignId,
          ipoId: ipoId,
          ipoNo: ipoNo,
          bpoId: bpoId,
          bpoNo: bpoNo,
          bpoStyleId: bpoStyleId,
          style: style,
          designId: designId,
          designNoColor: designNoColor,
          color: color,
          quality: quality,
          construction: construction,
          length: length,
          width: width,
          yarnCount: yarnCount,
          imageUrl: imageUrl,
          deliveryDt: deliveryDt,
        };
        localStorage.setItem("buyerDispatch", JSON.stringify(detail));
        window.open("/cs/buyerDispatch", "_blank");
      }
    }
  };

  stock = () => {
    var ipoNo = $("#ipoTableBody tr.selected").find(COL_IPO_IPONO).text();
    var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();
    var flag = "issueStock";
    if (ipoId !== "" || ipoId !== null) {
      var ipoDesignId = $("#ipoTableBody tr.selected")
        .find(COL_INTERNAL_IPODESIGNID)
        .text();
      var x = this.getBuyerPOData(ipoDesignId);
      if (x != -1) {
        var bpoId = x.bpoId;
        var bpoNo = x.bpo;
        var bpoStyleId = x.bpoStyleId;
        var style = x.style;
        var color = x.color;
        var designId = x.designId;
        var designNoColor = x.designNoColor;
        var ipoDesignId = x.ipoDesignId;
        var quality = x.quality;
        var construction = x.construction;
        var width = x.width;
        var length = x.length;
        var yarnCount = x.yarnCount;
        var imageName = x.img;
        var imageUrl =
          window.httpURL +
          "/a/mst/dsn/getImage?img=" +
          imageName +
          "&imgType=" +
          IMG_TYPES.DSN;
        if (ipoDesignId === "" || ipoDesignId === null || ipoDesignId === 0) {
          toast.warning("You can not add stock for this design");
          return false;
        }

        var detail = {
          flag: flag,
          ipoDesignId: ipoDesignId,
          ipoId: ipoId,
          ipoNo: ipoNo,
          bpoId: bpoId,
          bpoNo: bpoNo,
          bpoStyleId: bpoStyleId,
          style: style,
          designId: designId,
          designNoColor: designNoColor,
          color: color,
          quality: quality,
          construction: construction,
          length: length,
          width: width,
          yarnCount: yarnCount,
          imageUrl: imageUrl,
        };
        localStorage.setItem("stock", JSON.stringify(detail));
        window.open("/cs/issueStock", "_blank");
      }
    }
  };

  addTDCbx(row, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    cbx.name = "object";
    cbx.onclick = (e) => {
      e.stopPropagation();
    };
    cell.append(cbx);
    row.append(cell);
  }

  hideSlider(e) {
    e.preventDefault();
    $(".cd-panel").removeClass("is-visible");
    $(".main").removeClass("addOpacity");
    $(".designPopup").hide();
  }

  addTD(row, val, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var text = document.createTextNode(val);
    cell.append(text);
    row.append(cell);
  }

  addTDEdit(row, val, classname) {
    var cell = document.createElement("td");
    var span = document.createElement("span");
    cell.className = classname;
    span.className = val;
    span.style.position = "relative";
    span.style.cursor = "pointer";

    var ul = document.createElement("ul");
    ul.className = "ulStyle1";

    var li1 = document.createElement("li");
    var li2 = document.createElement("li");
    var li3 = document.createElement("li");
    var li4 = document.createElement("li");
    var li5 = document.createElement("li");
    var li6 = document.createElement("li");
    var li7 = document.createElement("li");

    li1.innerHTML = "Cancel PO Design";
    li2.innerHTML = "Delete PO";
    li3.innerHTML = "Edit Transporter";
    li4.innerHTML = "Update Progress";
    li5.innerHTML = "Weaver Dispatch";
    li6.innerHTML = "Buyer Dispatch";
    li7.innerHTML = "Add/Edit Stock";

    li1.onclick = (e) => {
      var ipoDesignId = $("#ipoTableBody tr.selected")
        .find(COL_INTERNAL_IPODESIGNID)
        .text();
      console.log("ipoDesignId= " + ipoDesignId);
      var x = window.confirm("Are you sure you want to cancel this PO Design?");
      if (x) {
        this.setState({ loader: "block", opacity: 0.5 });
        axiosInstance
          .post(
            httpURL + "/a/ipo/cancel_design",
            queryString.stringify({ ipoDesignId: parseInt(ipoDesignId) }),
            { withCredentials: true }
          )
          .then((response) => {
            if (response.data.SvcStatus === "Success") {
              toast.success(response.data.SvcMsg);
              $(e.target).closest("tr").remove();
            } else {
              toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: "none", opacity: 1 });
          })
          .catch((e) => {
            toast.error("Service failed " + e);
          });
      }
    };

    li2.onclick = (e) => {
      var ipoId = $("#ipoTableBody tr.selected").find(COL_IPO_IPOID).text();
      var x = window.confirm("Are you sure you want to delete this PO?");
      if (x) {
        this.setState({ loader: "block", opacity: 0.5 });
        axiosInstance
          .post(
            httpURL + "/a/ipo/delete",
            queryString.stringify({ ipoId: parseInt(ipoId) }),
            { withCredentials: true }
          )
          .then((response) => {
            if (response.data.SvcStatus === "Success") {
              toast.success(response.data.SvcMsg);
              $(e.target).closest("tr").remove();
            } else {
              toast.error(response.data.SvcMsg);
            }
            this.setState({ loader: "none", opacity: 1 });
          })
          .catch((e) => {
            toast.error("Service failed " + e);
          });
      }
    };

    li3.onclick = () => {
      $(".cd-panel").addClass("is-visible");
      $("#tptHeader, #tptSlider")
        .show()
        .siblings("#ipoHeader, #ipoSlider")
        .hide();
      $(".main").addClass("addOpacity");
      $(".designPopup").css("display", "block");
      this.setTptSlider();
    };

    li4.onclick = () => {
      this.progress();
    };

    li5.onclick = () => {
      this.dispatch();
    };

    li6.onclick = () => {
      this.buyerDispatch();
    };

    li7.onclick = () => {
      this.stock();
    };

    ul.append(li1);
    ul.append(li2);
    ul.append(li3);
    ul.append(li4);
    ul.append(li5);
    ul.append(li6);
    ul.append(li7);

    span.onclick = (e) => {
      $(ul).toggle();
      $(e.target.closest("tr")).siblings().find("span ul").hide();
      $(e.target.closest("tr"))
        .addClass("selected")
        .siblings()
        .removeClass("selected");
      this.handleResize();
    };
    span.append(ul);
    cell.append(span);
    row.append(cell);
  }

  addTDCbx(row, classname) {
    var cell = document.createElement("td");
    cell.className = classname;
    var cbx = document.createElement("input");
    cbx.type = "checkbox";
    cbx.name = "object";
    cbx.onclick = (e) => {
      e.stopPropagation();
    };
    cell.append(cbx);
    row.append(cell);
  }

  highlightRow(table, id) {
    $("#" + table + " tr").each(function () {
      var designId = $(this).find("td:eq(0)").text();
      if (designId == id) {
        $(this).addClass("selected").siblings().removeClass("selected");
      }
    });
  }

  selectTransporter = () => {
    console.log("Call");
    var trans = {};
    var ipoId = $("#inp_ipoIdT").val();
    var transporterId = $("#transportTableBody tr.selected")
      .find(COL_TPT_TPTID)
      .text();

    if (transporterId == "") {
      toast.warning("Please select transporter");
      return false;
    }
    trans = { ipoId, transporterId };

    axiosInstance
      .post(
        httpURL + "/a/ipo/savetrans",
        queryString.stringify({ trans: JSON.stringify(trans) }),
        { withCredentials: true }
      )
      .then((response) => {
        if (response.data.SvcStatus === "Success") {
          toast.success(response.data.SvcMsg);
          $(".cd-panel").removeClass("is-visible");
          $(".main").removeClass("addOpacity");
          $(".designPopup").hide();
        } else {
          toast.error(response.data.SvcMsg);
        }
        this.setState({ loader: "none", opacity: 1 });
      })
      .catch((e) => {
        toast.error("Service failed " + e);
      });
  };

  sortAscByCreated = () => {
    if (sortVal != "ascre") {
      sortVal = "ascre";
      $("#createdAsDtIcon").css("color", "gray");
      $("#createdDsDtIcon").css("color", "#111");

      var val1;
      var val2;

      for (var i = 0; i < lstIpo.length - 1; i++) {
        val1 = lstIpo[i].createDttm;
        for (var j = i + 1; j < lstIpo.length; j++) {
          val2 = lstIpo[j].createDttm;
          if (val1 > val2) {
            var tmp = lstIpo[j];
            lstIpo[j] = lstIpo[i];
            lstIpo[i] = tmp;
            val1 = lstIpo[i].createDttm;
          }
        }
      }
      this.setIpoTable();
    }
  };

  sortDesByCreated = () => {
    if (sortVal != "dscre") {
      sortVal = "dscre";
      $("#createdAsDtIcon").css("color", "#111");
      $("#createdDsDtIcon").css("color", "gray");

      var val1;
      var val2;

      for (var i = 0; i < lstIpo.length - 1; i++) {
        val1 = lstIpo[i].createDttm;
        for (var j = i + 1; j < lstIpo.length; j++) {
          val2 = lstIpo[j].createDttm;
          if (val1 < val2) {
            var tmp = lstIpo[j];
            lstIpo[j] = lstIpo[i];
            lstIpo[i] = tmp;
            val1 = lstIpo[i].createDttm;
          }
        }
      }
      this.setIpoTable();
    }
  };

  selectQuotes = () => {
    if ($("#cbx").is(":checked")) {
      allIpo = [];
      alert(tempList[5].quoteAcceptedStatus);
      for (var i = 0; i < tempList.length; i++) {
        if (tempList[i].quoteAcceptedStatus == true) {
          alert("Hello");
          allIpo.push(tempList[i]);
        }
      }
    } else {
      allIpo = tempList;
    }
    this.setIpoTable();
  };

  render() {
    httpURL = window.httpURL;
    return (
      <div style={{ height: "100%" }}>
        <Header />
        <ToastContainer autoClose={2000} hideProgressBar />
        <div
          style={{
            position: "fixed",
            width: 100,
            height: 100,
            marginLeft: -50,
            marginTop: -50,
            left: "50%",
            top: "50%",
            display: this.state.loader,
          }}
        >
          <img src={require("../images/loader.gif")} alt="Loader..." />
        </div>
        <div className="main" style={{ opacity: this.state.opacity }}>
          <div className="container-fluid">
            <div className="col-sm-12 col-centered">
              <div
                className="col-sm-12 padding-remove"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                <label htmlFor="inp_fromDate">From Date</label>
                <div style={{ marginLeft: 5, width: 100 }}>
                  <DatePicker
                    id="inp_fromDate"
                    className="form-control text-center"
                    placeholderText="From Date"
                    selected={this.state.startDate}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                    onChange={(date) => {
                      this.setState({ startDate: date });
                    }}
                  />
                </div>
                <label style={{ marginLeft: 10 }} htmlFor="inp_toDate">
                  To Date
                </label>
                <div style={{ marginLeft: 5, width: 100 }}>
                  <DatePicker
                    id="inp_toDate"
                    className="form-control text-center"
                    placeholderText="To Date"
                    selected={this.state.endDate}
                    dateFormat="dd-MM-yyyy"
                    autoComplete="off"
                    onChange={(date) => {
                      this.setState({ endDate: date });
                    }}
                  />
                </div>
                <button
                  style={{ marginLeft: 20 }}
                  type="button"
                  id="getData"
                  className="btn btn-warning"
                  onClick={this.getIpo}
                >
                  Get Data
                </button>
                <div className="quotesStatus">
                  <input type="checkbox" onChange={this.setIpoTable} id="cbx" />{" "}
                  <span className="ipoQuotes">Quotes Not Accepted</span>
                </div>
              </div>
              <div className="col-sm-12 padding-remove">
                <table
                  className="tableLayout1"
                  style={{ width: this.state.width }}
                >
                  <thead>
                    <tr>
                      <th style={{ width: 30, display: "none" }}>Quote Id</th>
                      <th style={{ width: 30, display: "none" }}>Ipo Id</th>
                      <th style={{ width: 25 }}>
                        <input
                          type="text"
                          onChange={this.setIpoTable}
                          className="form-control inp-search"
                          id="filterIpoNo"
                          placeholder="Ipo No"
                        />
                      </th>
                      <th style={{ width: 35 }}>
                        <div style={{ float: "left", marginLeft: "5%" }}>
                          Created On
                        </div>
                        <div
                          style={{
                            width: 10,
                            float: "left",
                            marginLeft: 2,
                            marginTop: -4,
                          }}
                        >
                          <div className="assending">
                            <span
                              id="createdAsDtIcon"
                              onClick={this.sortAscByCreated}
                              className="glyphicon glyphicon-triangle-top"
                            ></span>
                          </div>
                          <div className="desending">
                            <span
                              id="createdDsDtIcon"
                              onClick={this.sortDesByCreated}
                              className="glyphicon glyphicon-triangle-bottom"
                            ></span>
                          </div>
                        </div>
                      </th>
                      <th style={{ width: 30, display: "none" }}>Weaver Id</th>
                      <th style={{ width: 40 }}>
                        <input
                          type="text"
                          onChange={this.setIpoTable}
                          className="form-control inp-search"
                          id="filterWeaver"
                          placeholder="Weaver"
                        />
                      </th>
                      <th style={{ width: 50, display: "none" }}>BPO Id</th>
                      <th style={{ width: 50 }}>
                        <input
                          type="text"
                          onChange={this.setIpoTable}
                          className="form-control inp-search"
                          id="filterBpoNo"
                          placeholder="Bpo No."
                        />
                      </th>
                      <th style={{ width: 50, display: "none" }}>Season Id</th>
                      <th style={{ width: 30 }}>Season</th>
                      <th style={{ width: 30 }}>Delivery Dt</th>
                      <th style={{ width: 50, display: "none" }}>Style Id</th>
                      <th style={{ width: 30 }}>Style</th>
                      <th style={{ width: 30 }}>Color</th>
                      <th style={{ width: 50, display: "none" }}>Design Id</th>
                      <th style={{ width: 60 }}>
                        <input
                          type="text"
                          onChange={this.setIpoTable}
                          className="form-control inp-search"
                          id="filterDesignColor"
                          placeholder="Design Color"
                        />
                      </th>
                      <th style={{ width: 15 }}>Rate</th>
                      <th style={{ width: 40 }}>
                        Length | Width | Construction
                      </th>
                      <th style={{ width: 50, display: "none" }}>
                        Buffer Days
                      </th>
                      <th style={{ width: 40 }}>Yarn Count</th>
                      <th style={{ width: 50, display: "none" }}>Quality Id</th>
                      <th style={{ width: 30 }}>Quality</th>
                      <th style={{ width: 50, display: "none" }}>
                        IPO Design Id
                      </th>
                      <th style={{ width: 30, display: "none" }}>Status Id</th>
                      <th style={{ width: 35 }}>
                        <select
                          type="text"
                          onChange={this.setIpoTable}
                          className="form-control inp-search"
                          id="filterStatusCmb"
                        >
                          {" "}
                        </select>
                      </th>
                      <th style={{ width: 20 }}>Action</th>
                    </tr>
                  </thead>
                </table>
                <div className="col-sm-12 ipoTableDiv padding-remove">
                  <table id="ipoTable" className="tableLayout">
                    <colgroup>
                      <col width="25" />
                      <col width="35" />
                      <col width="40" />
                      <col width="50" />
                      <col width="30" />
                      <col width="30" />
                      <col width="30" />
                      <col width="30" />
                      <col width="60" />
                      <col width="15" />
                      <col width="40" />
                      <col width="40" />
                      <col width="30" />
                      <col width="35" />
                      <col width="20" />
                    </colgroup>
                    <tbody id="ipoTableBody"></tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="designPopup">
          <header style={{ width: "90%" }}>
            <h3 id="tptHeader">Chandrasilk Transporter Details</h3>
            <div id="ipoHeader">
              <label style={{ marginLeft: 15 }} htmlFor="inp_ipoNo">
                Ipo No:
              </label>
              <input
                readOnly
                style={{
                  marginLeft: 15,
                  width: 100,
                  height: 35,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: 5,
                }}
                type="text"
                className="inp-search text-right"
                id="inp_ipoNo"
                placeholder="Ipo No"
              />
              <label style={{ marginLeft: 15 }} htmlFor="inp_quoteId">
                Quote Id:
              </label>
              <input
                readOnly
                style={{
                  marginLeft: 15,
                  width: 100,
                  height: 35,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: 5,
                }}
                type="text"
                className="inp-search text-right"
                id="inp_quoteId"
                placeholder="Quote Id"
              />
              <label style={{ marginLeft: 15 }} htmlFor="inp_weaver">
                Weaver:
              </label>
              <input
                readOnly
                style={{
                  marginLeft: 15,
                  width: 200,
                  height: 35,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: 5,
                }}
                type="text"
                className="inp-search"
                id="inp_weaver"
                placeholder="Weaver"
              />
              <label style={{ marginLeft: 15 }} htmlFor="inp_createdOn">
                Created Date:
              </label>
              <input
                readOnly
                style={{
                  marginLeft: 15,
                  width: 100,
                  height: 35,
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: 5,
                }}
                type="text"
                className="inp-search text-center"
                id="inp_createdOn"
                placeholder="Created Date"
              />
            </div>
            <a
              href="#0"
              className="cd-panel-close glyphicon glyphicon-remove"
              onClick={this.hideSlider}
            >
              Close
            </a>
          </header>

          <div style={{ width: "90%" }}>
            <div
              className="cd-panel-content"
              style={{ padding: "70px 0% 20px" }}
            >
              <div
                id="tptSlider"
                className="col-sm-12"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ width: "70%" }}>
                  <div>
                    <label htmlFor="inp_ipoNoT">IPO NO.:</label>
                    <input
                      readOnly
                      style={{
                        marginLeft: 15,
                        width: 200,
                        height: 35,
                        border: "1px solid #ccc",
                        borderRadius: 6,
                        padding: 5,
                        backgroundColor: "#eee",
                      }}
                      type="text"
                      className="inp-search text-right"
                      id="inp_ipoNoT"
                      placeholder="Ipo No"
                    />
                    <input
                      style={{ display: "none" }}
                      type="text"
                      id="inp_ipoIdT"
                      placeholder="Ipo Id"
                    />
                  </div>
                  <table
                    className="tableLayout3"
                    style={{ width: this.state.width2, marginTop: 5 }}
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 5, display: "none" }}>Staff Id</th>
                        <th style={{ width: 110 }}>
                          {" "}
                          <input
                            type="text"
                            onChange={this.setTransporterTable}
                            className="form-control inp-search"
                            id="transportId"
                            placeholder="Transporter Id"
                          />
                        </th>
                        <th style={{ width: 130 }}>
                          {" "}
                          <input
                            type="text"
                            onChange={this.setTransporterTable}
                            className="form-control inp-search"
                            id="transporter"
                            placeholder="Transporter"
                          />
                        </th>
                        <th style={{ width: 150 }}>
                          {" "}
                          <input
                            type="text"
                            onChange={this.setTransporterTable}
                            className="form-control inp-search"
                            id="transportContactPerson"
                            placeholder="Contact Person"
                          />
                        </th>
                        <th style={{ width: 150 }}>
                          {" "}
                          <input
                            type="text"
                            onChange={this.setTransporterTable}
                            className="form-control inp-search"
                            id="transportCity"
                            placeholder="City"
                          />
                        </th>
                        <th style={{ width: 90 }}>
                          {" "}
                          <input
                            type="text"
                            onChange={this.setTransporterTable}
                            className="form-control inp-search"
                            id="transportPhone"
                            placeholder="Phone"
                          />
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div
                    className="col-sm-12 padding-remove"
                    style={{ height: 350, overflowY: "scroll" }}
                  >
                    <table id="transportTable" className="tableLayout">
                      <colgroup>
                        <col width="110" />
                        <col width="130" />
                        <col width="150" />
                        <col width="150" />
                        <col width="90" />
                      </colgroup>
                      <tbody id="transportTableBody"></tbody>
                    </table>
                  </div>
                  <div className="text-center" style={{ marginTop: 30 }}>
                    <button
                      type="button"
                      onClick={this.selectTransporter}
                      className="btn btn-warning"
                    >
                      Select
                    </button>
                  </div>
                </div>
                <div style={{ width: "30%", paddingLeft: 20 }}>
                  <h4 style={{ color: "#bb592b" }}>Current Transporter</h4>
                  <form id="transportAddForm" className="form-horizontal">
                    <div className="form-group">
                      <label
                        htmlFor="inp_transporterId"
                        className="control-label col-sm-6"
                      >
                        Transporter Id:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          id="inp_transporterId"
                          placeholder="Transporter Id"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="inp_transporter"
                        className="control-label col-sm-6"
                      >
                        Transporter:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          id="inp_transporter"
                          placeholder="Transporter"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="inp_contactPerson"
                        className="control-label col-sm-6"
                      >
                        Contact Person:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          id="inp_contactPerson"
                          placeholder="Contact Person"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="inp_city"
                        className="control-label col-sm-6"
                      >
                        City:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          id="inp_city"
                          placeholder="City"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="inp_phone"
                        className="control-label col-sm-6"
                      >
                        Phone:
                      </label>
                      <div className="col-sm-6 padding-remove">
                        <input
                          readOnly
                          type="text"
                          className="form-control"
                          id="inp_phone"
                          placeholder="Phone"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InternalPo;
